import { BASE_URL } from "@constants/common";
import getProductName from "@helpers/products/getProductName";

import { KlaviyoCartItem } from "@typings/analytics/klaviyo";
import { Product } from "@typings/product/product";

export const transformCartItemsToKlaviyo = (cartItems: Product[]): KlaviyoCartItem[] => {
  return cartItems.map((cartItem) => {
    const { item, configuration } = cartItem;
    const { id, category, tags, mainImage } = item;
    const { price, quantity, options, offer } = configuration;

    const productURL = `${BASE_URL}/shop/${item.id}`;

    return {
      ProductID: id,
      Name: getProductName(cartItem),
      OfferID: offer.id,
      Options: options,
      Quantity: quantity,
      Price: price,
      LineTotal: price * quantity,
      URL: productURL,
      MainImageURL: mainImage,
      Categories: [category.name, ...tags.map((t) => t.name)],
    };
  });
};
